import { render, staticRenderFns } from "./merchantQrcodeDialog2.vue?vue&type=template&id=7135ca34"
import script from "./merchantQrcodeDialog2.vue?vue&type=script&lang=js"
export * from "./merchantQrcodeDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports